export default "__VITE_ASSET__CZeAlVtC__"